"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { ArrowLeft, ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BackButton() {
  const router = useRouter();
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    setCanGoBack(window.history.length > 1);
  }, []);

  if (!canGoBack) return null;

  return (
    <button
      type="button"
      onClick={() => router.back()}
      className="cursor-pointer gap-2 whitespace-nowrap text-sm font-medium transition-all [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 size-8 static top-auto left-auto translate-y-0 h-8 w-8 rounded-full border border-input bg-background shadow-sm flex items-center justify-center disabled:opacity-40"
    >
      <ArrowLeft className="h-6 w-6" />
    </button>    
  )

  // return (
  //   <Button
  //     variant="ghost"
  //     size="sm"
  //     onClick={() => router.back()}
  //     className="gap-1 text-muted-foreground hover:text-foreground cursor-pointer"
  //   >
  //     <ArrowLeft className="h-4 w-4" />
  //   </Button>
  // );
}
